import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { BuyCoinType } from '@popup/steem/pages/app-container/home/buy-coins/buy-coin-type.enum';
import { BuyCoinsListItem } from '@popup/steem/pages/app-container/home/buy-coins/buy-coins-list-item.list';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import { SlidingBarComponent } from 'src/common-ui/switch-bar/sliding-bar.component';
const BuyCoins = ({ setTitleContainerProperties, currencyLabels, activeAccountName, }) => {
    const [selectedCurrency, setSelectedCurrency] = useState(BuyCoinType.BUY_STEEM);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_buy',
            isBackButtonEnabled: true,
        });
    }, []);
    const changeSelectedCurrency = (selectedValue) => {
        setSelectedCurrency(selectedValue);
    };
    const goTo = (url) => {
        chrome.tabs.create({ url: url });
    };
    return (React.createElement("div", { className: "buy-coins-page", "data-testid": `${Screen.BUY_COINS_PAGE}-page` },
        React.createElement(SlidingBarComponent, { dataTestId: "buy-coins", id: "buy-coins", onChange: changeSelectedCurrency, selectedValue: selectedCurrency, values: [
                {
                    value: BuyCoinType.BUY_STEEM,
                    label: currencyLabels.steem,
                    skipLabelTranslation: true,
                },
                {
                    value: BuyCoinType.BUY_SBD,
                    label: currencyLabels.sbd,
                    skipLabelTranslation: true,
                },
            ] }),
        React.createElement("div", { className: "list" },
            BuyCoinsListItem(selectedCurrency, activeAccountName).list.map((item, index) => (React.createElement("div", { className: "card", key: `card-item-${index}` },
                React.createElement(SVGIcon, { icon: item.image, onClick: () => goTo(item.link) }),
                React.createElement("span", { className: "title" }, item.name),
                React.createElement("span", { className: "description" }, getMessage(item.description)),
                React.createElement(ButtonComponent, { additionalClass: "buy-button", onClick: () => goTo(item.link), label: 'popup_html_buy', type: ButtonType.IMPORTANT })))),
            React.createElement("div", { className: "card exchanges-card" },
                React.createElement("div", { className: "title" }, getMessage('html_popup_exchanges')),
                React.createElement("div", { className: "exchange-list" }, BuyCoinsListItem(selectedCurrency, activeAccountName).exchanges.map((item, index) => (React.createElement("div", { className: "exchange-item", key: `exchange-item-${index}`, onClick: () => goTo(selectedCurrency == BuyCoinType.BUY_SBD
                        ? item.link_sbd
                        : item.link) },
                    React.createElement(SVGIcon, { icon: item.image })))))))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        activeAccountName: state.steem.activeAccount.name,
    };
};
const connector = connect(mapStateToProps, { setTitleContainerProperties });
export const BuyCoinsComponent = connector(BuyCoins);
